import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

// Firebase configuration - Replace with your actual config from Firebase Console
const firebaseConfig = {
  apiKey: "AIzaSyA5yEw6sBjk0m6x49fTn7z5lX098YssF4w",
  authDomain: "reward-469408.firebaseapp.com",
  projectId: "reward-469408",
  storageBucket: "reward-469408.firebasestorage.app",
  messagingSenderId: "522444835476",
  appId: "1:522444835476:web:e06599f8b8601683f98281",
  measurementId: "G-VSLTNQ5EKN", // Replace with your app ID
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Authentication and get a reference to the service
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();

// Configure Google Auth Provider
googleProvider.setCustomParameters({
  prompt: 'select_account'
});

// Initialize Cloud Firestore and get a reference to the service
export const db = getFirestore(app);

export default app;
